import { useState } from 'react';

import { PermissionGate } from '@/auth/PermissionGate';
import { Campo } from '@/components/Campo';
import { Cargando, Encabezado, ErrorCarga } from '@/components/Estados';
import { Barras, Columnas } from '@/components/Graficas';
import { mesCorto, mxn } from '@/lib/formato';

import { useEstadisticas } from './queries';

function Estadisticas() {
  const [rango, setRango] = useState<{ from?: string; to?: string }>({});
  const q = useEstadisticas(rango);
  const d = q.data;
  return (
    <>
      <Encabezado
        titulo="Estadísticas"
        descripcion="Por mes, en hora de Ciudad de México. Por omisión, los últimos 12 meses."
      />
      <form
        className="panel-vidrio mb-4 flex flex-wrap items-end gap-3"
        onSubmit={(e) => {
          e.preventDefault();
          const f = new FormData(e.currentTarget);
          const from = (f.get('from') as string | null) ?? '';
          const to = (f.get('to') as string | null) ?? '';
          setRango(from && to ? { from, to } : {});
        }}
      >
        <Campo etiqueta="Desde">
          <input
            name="from"
            type="date"
            className="input-vidrio"
            defaultValue={d?.from}
            key={`f${d?.from}`}
          />
        </Campo>
        <Campo etiqueta="Hasta">
          <input
            name="to"
            type="date"
            className="input-vidrio"
            defaultValue={d?.to}
            key={`t${d?.to}`}
          />
        </Campo>
        <button type="submit" className="btn-cs btn-primario">
          Aplicar
        </button>
        {rango.from && (
          <button type="button" className="btn-cs btn-contorno" onClick={() => setRango({})}>
            Últimos 12 meses
          </button>
        )}
      </form>
      {q.isPending && <Cargando />}
      {q.isError && <ErrorCarga error={q.error} onReintentar={() => void q.refetch()} />}
      {d && (
        <div className="grid gap-6 xl:grid-cols-2">
          <Columnas
            titulo="Registros por mes"
            subtitulo="Cuentas nuevas; las que ya tienen alguna licencia, en azul"
            series={[
              { clave: 'con', nombre: 'Con licencia', color: 'var(--serie-1)' },
              { clave: 'sin', nombre: 'Sin licencia', color: 'var(--serie-2)' },
            ]}
            datos={d.registrations.map((r) => ({
              etiqueta: mesCorto(r.month),
              valores: { con: r.withMembership, sin: r.total - r.withMembership },
            }))}
          />
          <Columnas
            titulo="Ventas por mes"
            subtitulo="Pagos confirmados (MXN)"
            series={[{ clave: 'total', nombre: 'Ventas', color: 'var(--serie-1)' }]}
            datos={d.sales.map((s) => ({
              etiqueta: mesCorto(s.month),
              valores: { total: Number(s.total) },
            }))}
            formato={(v) => mxn(v).replace('.00', '')}
          />
          <Barras
            titulo="Alumnos con licencia vigente"
            subtitulo="Hoy, por licencia (top 20)"
            etiquetaValor="Alumnos"
            datos={d.activeByMembership.map((m) => ({ etiqueta: m.name, valor: m.students }))}
          />
          <Barras
            titulo="Casos base por especialidad"
            subtitulo="Banco de casos (sin subsecuentes)"
            etiquetaValor="Casos"
            datos={d.questionsBySpecialty.map((s) => ({
              etiqueta: s.specialty,
              valor: s.questions,
            }))}
          />
        </div>
      )}
    </>
  );
}

export function EstadisticasPage() {
  return (
    <PermissionGate seccion="reportes">
      <Estadisticas />
    </PermissionGate>
  );
}
